import classNames from 'classnames'
import i18next from 'i18next'
import { HTMLAttributes } from 'react'
import { IconButton } from '../icon-button'
import styles from './index.module.css'

interface Props extends HTMLAttributes<HTMLDivElement> {
  page: number
  isLastPage: boolean
  onPageChange: (page: number) => void
}

export const TablePaginationSimple = ({ page, isLastPage, className, onPageChange, ...props }: Props) => {
  return (
    <div className={classNames(className, styles.container)} role="navigation" {...props}>
      <IconButton
        disabled={page === 1}
        aria-label="Previous page"
        onClick={() => onPageChange(page - 1)}
        className="ml-4 mr-2"
        icon="chevron-left"
        size="sm"
      />
      <span className="capitalize">{`${i18next.t('glow.page')} ${page}`}</span>

      <IconButton
        disabled={isLastPage}
        className="ml-2"
        aria-label="Next page"
        onClick={() => onPageChange(page + 1)}
        icon="chevron-right"
        size="sm"
      />
    </div>
  )
}
